











































































































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import Api from "@/api";
import FormErrorsMixin from "@/mixins/FormErrors";
import BaseMixin from "@/mixins/BaseMixin";
import { AxiosResponse } from "axios";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/de";

import NavigationTabs from "@/components/Settings/Events/EventDetails/NavigationTabs.vue";

import ViewLoader from "@/components/Common/ViewLoader.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import BackButton from "@/components/Common/Buttons/BackButton.vue";
import Error404 from "@/components/Common/Error404.vue";
import { IEvent, IVenue } from "@/interface";

interface IWeekDay {
  id: number;
  abbr: string;
  name: string;
  checked: boolean;
  starts_at: Date | null;
  ends_at: Date | null;
  venue_id: number;
}

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    NavigationTabs,
    InfoButton,
    BackButton,
    DatePicker,
    Error404
  }
})
export default class EventDateSettings extends Mixins(
  FormErrorsMixin,
  BaseMixin
) {
  public loading = false;
  public updating = false;
  public validatedInputs = [
    "starts_at",
    "ends_at",
    "date_settings.monday.appointments.0.starts_at",
    "date_settings.monday.appointments.0.ends_at",
    "date_settings.monday.appointments.0.venue_id",
    "date_settings.tuesday.appointments.0.starts_at",
    "date_settings.tuesday.appointments.0.ends_at",
    "date_settings.tuesday.appointments.0.venue_id",
    "date_settings.wednesday.appointments.0.starts_at",
    "date_settings.wednesday.appointments.0.ends_at",
    "date_settings.wednesday.appointments.0.venue_id",
    "date_settings.thursday.appointments.0.starts_at",
    "date_settings.thursday.appointments.0.ends_at",
    "date_settings.thursday.appointments.0.venue_id",
    "date_settings.friday.appointments.0.starts_at",
    "date_settings.friday.appointments.0.ends_at",
    "date_settings.friday.appointments.0.venue_id",
    "date_settings.saturday.appointments.0.starts_at",
    "date_settings.saturday.appointments.0.ends_at",
    "date_settings.saturday.appointments.0.venue_id",
    "date_settings.sunday.appointments.0.starts_at",
    "date_settings.sunday.appointments.0.ends_at",
    "date_settings.sunday.appointments.0.venue_id"
  ];
  private noDataExist = false;
  private space = "\xa0";
  private dateFormat = "DD.MM.YYYY";
  private timeFormat = "HH:mm:ss";
  private venues: Array<IVenue> = [];
  private weekdays: Array<IWeekDay> = [
    {
      id: 0,
      abbr: "MO",
      name: "monday",
      checked: false,
      starts_at: null,
      ends_at: null,
      venue_id: 1
    },
    {
      id: 1,
      abbr: "TU",
      name: "tuesday",
      checked: false,
      starts_at: null,
      ends_at: null,
      venue_id: 1
    },
    {
      id: 2,
      abbr: "WE",
      name: "wednesday",
      checked: false,
      starts_at: null,
      ends_at: null,
      venue_id: 1
    },
    {
      id: 3,
      abbr: "TH",
      name: "thursday",
      checked: false,
      starts_at: null,
      ends_at: null,
      venue_id: 1
    },
    {
      id: 4,
      abbr: "FR",
      name: "friday",
      checked: false,
      starts_at: null,
      ends_at: null,
      venue_id: 1
    },
    {
      id: 5,
      abbr: "SA",
      name: "saturday",
      checked: false,
      starts_at: null,
      ends_at: null,
      venue_id: 1
    },
    {
      id: 6,
      abbr: "SU",
      name: "sunday",
      checked: false,
      starts_at: null,
      ends_at: null,
      venue_id: 1
    }
  ];

  private selectedEventId: string | null = null;
  private selectedEvent: IEvent = {
    name: null,
    start_date: null,
    end_date: null
  };

  private eventDateSettings: any = {
    date_settings: {
      monday: {
        appointments: [
          {
            starts_at: null,
            ends_at: null,
            venue_id: null
          }
        ]
      },
      tuesday: {
        appointments: [
          {
            starts_at: null,
            ends_at: null,
            venue_id: null
          }
        ]
      },
      wednesday: {
        appointments: [
          {
            starts_at: null,
            ends_at: null,
            venue_id: null
          }
        ]
      },
      thursday: {
        appointments: [
          {
            starts_at: null,
            ends_at: null,
            venue_id: null
          }
        ]
      },
      friday: {
        appointments: [
          {
            starts_at: null,
            ends_at: null,
            venue_id: null
          }
        ]
      },
      saturday: {
        appointments: [
          {
            starts_at: null,
            ends_at: null,
            venue_id: null
          }
        ]
      },
      sunday: {
        appointments: [
          {
            starts_at: null,
            ends_at: null,
            venue_id: null
          }
        ]
      }
    }
  };

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedEventId = vm.$route.params.event_id;
      if (
        typeof vm.selectedEventId !== "undefined" &&
        vm.selectedEventId !== null
      ) {
        vm.getVenues(() => {
          //
        });
        vm.getEvent(() => {
          //
        });
        vm.getEventDateSettings(() => {
          //
        });
      } else {
        this.$router.push({
          name: "Events"
        });
      }
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (
      typeof this.selectedEventId !== "undefined" &&
      this.selectedEventId !== null
    ) {
      this.getVenues(() => {
        //
      });
      this.getEvent(() => {
        //
      });
      this.getEventDateSettings(() => {
        //
      });
    } else {
      this.$router.push({
        name: "Events"
      });
    }
    next();
  }

  private toggleCheckbox(weekdayId: number): void {
    this.weekdays[weekdayId].checked = !this.weekdays[weekdayId].checked;
  }

  private getEventDateSettings(successCallback?: any): void {
    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId + "/date-settings"
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        for (let i = 0; i < this.weekdays.length; i++) {
          if (
            response.data.date_settings[this.weekdays[i].name].appointments
              .length > 0
          ) {
            this.weekdays[i].checked = true;
            this.weekdays[i].starts_at =
              response.data.date_settings[
                this.weekdays[i].name
              ].appointments[0].starts_at;
            this.weekdays[i].ends_at =
              response.data.date_settings[
                this.weekdays[i].name
              ].appointments[0].ends_at;
            this.weekdays[i].venue_id =
              response.data.date_settings[
                this.weekdays[i].name
              ].appointments[0].venue_id;
          } else {
            this.weekdays[i].checked = false;
            this.weekdays[i].starts_at = null;
            this.weekdays[i].ends_at = null;
          }
        }
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private updateEventDateSettings(): void {
    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId + "/date-settings"
    );

    for (let i = 0; i < this.weekdays.length; i++) {
      if (
        this.weekdays[i].checked &&
        this.weekdays[i].starts_at != null &&
        this.weekdays[i].ends_at != null
      ) {
        this.eventDateSettings.date_settings[
          this.weekdays[i].name
        ].appointments[0] = {
          starts_at: this.weekdays[i].starts_at,
          ends_at: this.weekdays[i].ends_at,
          venue_id: this.weekdays[i].venue_id
        };
      } else {
        this.eventDateSettings.date_settings[
          this.weekdays[i].name
        ].appointments = [];
      }
    }

    Api()
      .put(endpoint, this.eventDateSettings)
      .then(() => {
        this.getEventDateSettings();
      })
      .catch((error: any) => {
        console.log(error);
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private getEvent(successCallback?: any): void {
    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedEvent = response.data.data;
        this.selectedEvent.start_date = this.convertDate(
          this.selectedEvent.start_date,
          response.data.data.start_date
        ) as Date;
        this.selectedEvent.end_date = this.convertDate(
          this.selectedEvent.end_date,
          response.data.data.end_date
        ) as Date;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private getVenues(successCallback?: any): void {
    if (this.loading) {
      return;
    }

    this.loading = true;
    this.venues = [];
    const endpoint: string = this.$partnerEndpoint("venues");

    Api()
      .get(endpoint, {
        params: {
          page: 1,
          search: ""
        }
      })
      .then((response: AxiosResponse) => {
        this.venues = response.data.data;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
